import {z} from 'zod';

import {ScopeValues} from '@dms/api/shared';

export const evaluateTireWarehouse = (scopes: string[], evaluatorParams: ScopeValues) => {
  const {tireWarehouses} = validateTireWarehouseEvaluatorParams(evaluatorParams);

  if (tireWarehouses === 'SKIP') {
    return true;
  }

  return scopes.some((scope) => tireWarehouses.includes(scope));
};

const validateTireWarehouseEvaluatorParams = (evaluatorParams: ScopeValues | null) =>
  tireWarehouseParamsSchema.parse(evaluatorParams);

const tireWarehouseParamsSchema = z.object({
  tireWarehouses: z.union([z.array(z.string()), z.literal('SKIP')]),
});
